import ImageDropzone from './ImageDropzone';

/**
 * Label + upload zone (preview aktif digabung di dalam zone jika compact).
 */
const ImageUploadField = ({
    label,
    hint = 'PNG atau JPG · maks. 1MB · drag & drop',
    required = false,
    currentUrl,
    file,
    onFileChange,
    disabled = false,
    accept = 'image/png,image/jpeg,image/jpg',
    validateFile,
    previewAlt = 'Preview',
    previewClassName = 'max-h-20 w-auto max-w-full object-contain',
    activeLabel = 'File aktif',
    emptyTitle,
    compact = false,
}) => {
    const previewUrl = !file && currentUrl ? currentUrl : null;

    if (compact) {
        return (
            <div className="space-y-1.5">
                {label ? (
                    <label className="block text-sm font-medium text-ink dark:text-white">
                        {label}
                        {required ? <sup className="ml-0.5 text-accent-brand">*</sup> : null}
                    </label>
                ) : null}

                <ImageDropzone
                    file={file}
                    onFileChange={onFileChange}
                    disabled={disabled}
                    accept={accept}
                    validateFile={validateFile}
                    hint={hint}
                    emptyTitle={emptyTitle}
                    previewUrl={previewUrl}
                    compact
                />
            </div>
        );
    }

    return (
        <div className="space-y-2">
            {label ? (
                <label className="block text-sm font-medium text-ink dark:text-white">
                    {label}
                    {required ? <sup className="ml-0.5 text-accent-brand">*</sup> : null}
                </label>
            ) : null}

            {currentUrl && !file ? (
                <div className="rounded-md border border-hairline bg-surface-soft p-3 dark:border-white/10 dark:bg-white/5">
                    <p className="mb-2 text-[11px] font-medium uppercase tracking-wider text-muted">
                        {activeLabel}
                    </p>
                    <img
                        src={currentUrl}
                        alt={previewAlt}
                        className={previewClassName}
                    />
                </div>
            ) : null}

            <ImageDropzone
                file={file}
                onFileChange={onFileChange}
                disabled={disabled}
                accept={accept}
                validateFile={validateFile}
                hint={hint}
                emptyTitle={emptyTitle}
            />
        </div>
    );
};

export default ImageUploadField;
